import { Component, ElementRef, HostListener } from '@angular/core';
import { LocaleService } from '@shared/services/locale.service';

interface LanguageOption {
  code: 'zh' | 'en';
  label: string;
}

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent {
  readonly options: LanguageOption[] = [
    { code: 'zh', label: '中文' },
    { code: 'en', label: 'English' }
  ];

  isOpen = false;

  constructor(public locale: LocaleService, private elRef: ElementRef<HTMLElement>) {}

  get currentCode(): 'zh' | 'en' {
    return this.locale.isEn ? 'en' : 'zh';
  }

  get currentLabel(): string {
    return this.options.find(o => o.code === this.currentCode)?.label ?? this.options[0].label;
  }

  hrefFor(code: 'zh' | 'en'): string {
    if (code === this.currentCode) return '#';
    return this.locale.swapLocaleUrl(window.location.pathname, window.location.hash);
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  onOptionClick(opt: LanguageOption, event: Event): void {
    if (opt.code === this.currentCode) {
      event.preventDefault();
      this.isOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen) return;
    if (!this.elRef.nativeElement.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.isOpen = false;
  }
}
